import angular from 'angular';
import modalConfirmation from '../shared/components/modal-response/modal-response.view.html';
import modalExperience from './modal-experience/modal-experience.view.html';
import ModalExperienceController from "./modal-experience/modal-experience.controller";

let inject = [
    '$scope',
    'ConfirmationOrderService',
    '$state',
    '$rootScope',
    'SharedService',
    '$uibModal',
    '$timeout',
    '$stateParams',
    '$window'
];

class ConfirmationOrderController {
    constructor($scope, ConfirmationOrderService, $state, $rootScope, SharedService, $uibModal, $timeout, $stateParams, $window) {
        this.$state = $state;
        this.$scope = $scope;
        this.$window = $window;
        this.$timeout = $timeout;
        this.$rootScope = $rootScope;
        this.$stateParams = $stateParams;
        this.$uibModal = $uibModal;
        this.ConfirmationOrderService = ConfirmationOrderService;
        this.SharedService = SharedService;
        this.orderId = this.$stateParams.orderId;
        this.loadingDataOrder = true;
        this.orderData = {};
        this.resolving = this.$stateParams.resolve === 'true';
        this.alreadySend = false;


        this.showBottomInfo = __env.clientName === 'laskin';

    }

    $onInit() {
        this.getOrder();
    }

    getOrder() {
        this.loadingDataOrder = true;
        let userId = '', sellerId = '';
        try {
            userId = this.shCtrl.globals.currentUser.userId;
        } catch (e) {

        }

        try {
            sellerId = this.shCtrl.globals.currentUser.sellerId;
        }
        catch (e) {
        }
        this.ConfirmationOrderService.getOrderById(userId, sellerId, this.orderId).then(response => {

            if (!response.error) {
                this.orderData = response.data.order;
                this.orderData.totalPesoItems = 0;
                this.orderData.cantidadTotalCanasta = 0;

                // this.orderData.experience_comment
                this.products=[];
                response.data.order.items.forEach(val => {
                    this.products.push({
                        'item_name': val.nombre,     // Name or ID is required.
                        'item_id': val.id,
                        'price': val.precio_unitario,
                        'item_category': val.slug,
                        'quantity': val.cantidad, 
                    });
                    this.orderData.totalPesoItems += val.cantidad * val.peso_embalaje;
                    this.orderData.cantidadTotalCanasta += val.cantidad;
                });
                if (this.orderData.medioPago.pasarela_pago_id === null){
                  this.$window.dataLayer.push({
                    'event': 'purchase',
                    'ecommerce': {
                          'transaction_id': response.data.order.id,                         // Transaction ID. Required for purchases and refunds.
                          'affiliation': 'Tienda Virtual',
                          'value': response.data.order.total,                     // Total transaction value (incl. tax and shipping)
                          'tax':response.data.order.impuestos,
                          'shipping': response.data.order.gestion_y_transporte,
                          'currency': "COP",
                          'coupon': response.data.order.descuentos , 
                          'items': this.products
                    }
                  });
                  console.log(this.$window.dataLayer);
                }

            } else {

                alert('Ha ocurrido un error al obtener los datos');
            }
             this.loadingDataOrder = false;
        })
    }

    payNow() {
        this.$window.location = window.__env.envApiServiceBaseUri + '/order/pay-gate?id=' + this.orderData.id;
    }

    openExperienceModal() {
        let modalInstance = this.$uibModal.open({
            animation: true,
            template: modalExperience,
            controller: 'ModalExperienceController',
            controllerAs: 'mdCtrl',
            resolve: {
                orderData: () => this.orderData
            }
        });
        modalInstance.result.then((value) => {

            if(!value.error){
                this.alreadySend = true;
                this.orderData["experience_comment"]= value.data.experience_comment;
                this.orderData["experience_rating"]= value.data.experience_rating;
            }

            let options = {
                title: '',
                isHtml: false,
                content: value.message,
                size: '',
                showBottonCancel: false,
                textActionCancel: '',
                textAction: 'Aceptar'
            };
            this.messageResponse(options);
        }).catch(reason => {
            console.log(reason);
        });
    }


    messageResponse(options, callAcept, callback, callCancel, callbackCancel) {
        let modalInstance = this.$uibModal.open({
            animation: true,
            template: modalConfirmation,
            controller: 'ModalResponseController',
            controllerAs: 'mdCtrl',
            size: options.size,
            resolve: {
                modalOptions: () => options
            }
        });
        modalInstance.result.then(() => {
            if (callAcept) {
                callback();
            }
        }).catch(reason => {
            if (callCancel) {
                callbackCancel();
            }
        });
    }
}

ConfirmationOrderController.$inject = inject;

export default ConfirmationOrderController;




// WEBPACK FOOTER //
// ./www/components/confirmation-order/confirmation-order.controller.js